import React from 'react'
import PropTypes from 'prop-types'
import { Navbar } from 'reactstrap'
import { I18N, I18NConsumer } from 'commons'
import { setPageTitle } from 'utils'
import Footer from '../app/Footer'

const ErrorPage = ({ orgName }) => (
  <div>
    <a href="#main_content" className="sr-only sr-only-focusable">
      <I18N>global.skip.to.main.content</I18N>
    </a>
    <header>
      <div className="container banner no-image">
        <I18N tag="strong" i18n-title="">
          {`welcome.h3, ${orgName}`}
        </I18N>
      </div>
    </header>
    <div className="nav-box">
      <Navbar
        color="dark"
        dark
        expand="md"
        style={{
          padding: '28.5px 0',
        }}
      />
    </div>
    <main id="main_content" className="container" tabIndex="-1">
      <div className="well ssp-well">
        <I18NConsumer>
          {(i18n) => {
            setPageTitle(i18n['comms.error.page.title'])
            return (
              <div className="offset-sm-1 col-sm-11">
                <div className="error-page error-401">
                  <p className="title">
                    <I18N>comms.error.page.message</I18N>
                  </p>
                </div>
              </div>
            )
          }}
        </I18NConsumer>
      </div>
    </main>
    <Footer />
  </div>
)

ErrorPage.propTypes = {
  orgName: PropTypes.string,
}

ErrorPage.defaultProps = {
  orgName: '',
}

export default ErrorPage
